// extracted by mini-css-extract-plugin
export var cardStyle = "CardsWithSummaries-module--cardStyle--a195e";
export var cardWithSummary = "CardsWithSummaries-module--cardWithSummary--26875";
export var cards = "CardsWithSummaries-module--cards--c435d";
export var section = "CardsWithSummaries-module--section--ae7d7";